import React, { useMemo } from 'react';
import { ColorRepresentation, DoubleSide, Shape } from 'three';

import { Polygon3D } from '@paragon/geometry-library';
import { getMatrixFromIsometry } from '@paragon/three-shared';

import { LayoutPolygonVisualMode } from '../common/mode';

export function LayoutPolygonFaceMesh(props: {
  geometry: Polygon3D;

  mode: Exclude<LayoutPolygonVisualMode, 'wireframe'>;
  color: ColorRepresentation;

  visible?: boolean;
}) {
  const { visible = true } = props;
  const { shape, matrix } = useMemo(() => getShapeAndMatrixForPolygon(props.geometry), [props.geometry]);

  return (
    <mesh matrix={matrix} matrixAutoUpdate={false}>
      <shapeGeometry args={[shape]} />
      <meshBasicMaterial
        visible={visible}
        transparent
        depthWrite={props.mode !== 'translucent'}
        side={DoubleSide}
        color={props.color}
        opacity={props.mode === 'translucent' ? 0.3 : 1}
      />
    </mesh>
  );
}

function getShapeAndMatrixForPolygon(geometry: Polygon3D) {
  const shape = new Shape().moveTo(
    geometry.mappedTo2D.vertices[geometry.mappedTo2D.vertices.length - 1].x,
    geometry.mappedTo2D.vertices[geometry.mappedTo2D.vertices.length - 1].y,
  );

  for (const vertex of geometry.mappedTo2D.vertices) {
    shape.lineTo(vertex.x, vertex.y);
  }

  const matrix = getMatrixFromIsometry(geometry.embedding.toIsometry());

  return { shape, matrix };
}
